// extracted by mini-css-extract-plugin
module.exports = {"container":"blog_container__k4izA","publishedText":"blog_publishedText__YMG4M","title":"blog_title__2hcXb","contentContainer":"blog_contentContainer__tzwgk"};